<div *ngIf="data && data.action === 'delete'; else onCgrpOff" class="popup-main-content-container">
    <h2 class="popup-title"></h2>
    <div class="main-content-container">Confirmez-vous la suppression ?</div>
    <mat-dialog-actions class="buttons-container">
        <div class="button-edit">
            <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler
            </button>
            <button class="tv-ns-validation-large-button" (click)="okDeleteButtonClick()">Valider</button>
        </div>
    </mat-dialog-actions>
</div>

<ng-template #onCgrpOff>
    <div class="container">
        <div class="title-container">
            <h2 class="mat-title" *ngIf="data && data.action === 'new'">Ajout d'un CGRP Off</h2>
            <h2 class="mat-title" *ngIf="data && data.action === 'edit'">Modification</h2>
            <h2 class="mat-title" *ngIf="data && data.action === 'dup'">Duplication</h2>
        </div>
        <ng-container *ngIf="!saving; else savingContentTemplate">
            <div class="tv-ns-custom-horizontal-divider"></div>
            <div class="dialog-form-content tv-custom-always-visible-scroll-bar" [attr.aria-busy]="isLoading">
                <div class="dialog-fields" [attr.inert]="isLoading ? '' : null">
                    <div class="bloc-container">
                        <h4 class="red-title">Général</h4>
                        <div class="inputs-container">
                            <!-- Target -->

                            <!-- Search Item -->
                            <div class="tv-rect-input-extensible flex-auto">
                                <mat-form-field>
                                    <mat-label>Cible</mat-label>
                                    <input
                                            class="tv-ns-select-option"
                                            type="text"
                                            matInput
                                            [formControl]="targetControl"
                                            [matAutocomplete]="auto"/>
                                    <mat-autocomplete
                                            class="tv-custom-always-visible-scroll-bar"
                                            #auto="matAutocomplete"
                                            [displayWith]="displayTarget">
                                        <mat-option
                                                *ngFor="let item of filteredTargetList | async; trackBy: trackByTargetId"
                                                class="tv-ns-select-option"
                                                [value]="item">
                                            {{ item.name }} ({{ item.id }})
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <div class="tv-input-error-message"
                                     *ngIf="targetControl.touched && targetControl.hasError('required')">
                                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                                    <span class="tv-input-error-text">Veuillez renseigner une cible</span>
                                </div>
                            </div>

                            <!-- Date Range -->
                            <custom-date-range-picker
                                    [ngModel]="{
                                    start: itemsFilterForm.get('startDate')?.value,
                                    end: itemsFilterForm.get('endDate')?.value
                                }"
                                    [ngModelOptions]="{ standalone: true }"
                                    (ngModelChange)="
                                    itemsFilterForm.patchValue({ startDate: $event ? $event.start : null, endDate: $event ? $event.end : null })
                                "
                                    [min]="editStartDate"
                                    [max]="editEndDate"
                                    [styleType]="'squared'"
                                    valueFormat="dd/MM/yyyy"
                                    [required]="true">
                            </custom-date-range-picker>

                            <!-- CA in €  -->
                            <div class="tv-rect-input-extensible">
                                <mat-form-field>
                                    <mat-label>CT/GRP</mat-label>
                                    <input type="number" matInput [formControl]="budgetControl"/>
                                    <span matSuffix>€</span>
                                </mat-form-field>
                                <div class="tv-input-error-message"
                                     *ngIf="budgetControl.touched && budgetControl.hasError('required')">
                                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                                    <span class="tv-input-error-text">Veuillez saisir une valeur</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add-category-bloc-container" *ngIf="noCategoryBlockAdded; else test">
                        <span>Conditions</span>
                        <div>
                            <mat-icon class="type-icon" svgIcon="add-circle-fill"
                                      (click)="addCategoryBloc('Inclus')"></mat-icon>
                        </div>
                    </div>

                    <ng-template #test>
                        <div class="bloc-container">
                            <h4 class="red-title">{{ categoryConditionType }}</h4>
                            <div class="inputs-container condition-inputs-container">
                                <!-- Category -->
                                <div *ngIf="!isCategoryTypeLoading" class="tv-container-select-white-rect-extensible">
                                    <mat-form-field>
                                        <mat-label>Catégorie de la négo</mat-label>
                                        <mat-select panelClass="tv-custom-always-visible-scroll-bar"
                                                    [formControl]="categoryTypeFormControl">
                                            <mat-option *ngFor="let category of categoryTypeList"
                                                        class="tv-ns-select-option" [value]="category">
                                                {{ category.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- Search -->
                                <!-- Search Item -->
                                <div class="search-item-container">
                                    <div class="tv-rect-input-extensible">
                                        <mat-form-field>
                                            <mat-label>Rechercher</mat-label>
                                            <input
                                                    class="tv-ns-select-option"
                                                    type="text"
                                                    aria-label="Number"
                                                    matInput
                                                    #itemAutocompleteTrigger="matAutocompleteTrigger"
                                                    [formControl]="searchFormControl"
                                                    [matAutocomplete]="auto"/>
                                            <mat-autocomplete
                                                    class="tv-custom-always-visible-scroll-bar"
                                                    #auto="matAutocomplete"
                                                    [displayWith]="displayItem">
                                                <mat-option
                                                        *ngFor="let item of filteredItemList | async; trackBy: trackByItemId"
                                                        class="tv-ns-select-option"
                                                        [value]="item">
                                                    {{ item.name }} ({{ item.id }})
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <button
                                        type="button"
                                        [disabled]="isFilteredItemListFill() || isSelectItemsDialogOpen"
                                        (click)="listAllOptions()"
                                        class="tv-round-icon-button-icon-medium-light-blue">
                                    <mat-spinner *ngIf="isItemLoading; else listIconTemplate" diameter="20"
                                                 class="light-spinner"></mat-spinner>
                                    <ng-template #listIconTemplate>
                                        <mat-icon>list</mat-icon>
                                    </ng-template>
                                </button>
                            </div>
                            <div *ngIf="conditionRows.length > 0" class="conditions-table-container">
                                <div class="conditions-table-scroll tv-custom-always-visible-scroll-bar">
                                    <table mat-table [dataSource]="conditionRows"
                                           class="tv-ns-mat-table conditions-table">
                                        <ng-container matColumnDef="category">
                                            <th mat-header-cell *matHeaderCellDef>Catégorie de négo
                                                ({{ conditionCategoryCount }})
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <span class="condition-cell-text"
                                                      [attr.title]="row.categoryType?.name">{{ row.categoryType?.name }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef>Nom ({{ conditionRows.length }})</th>
                                            <td mat-cell *matCellDef="let row">
                                                <span class="condition-cell-text"
                                                      [attr.title]="row.category.name">{{ row.category.name }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="number">
                                            <th mat-header-cell *matHeaderCellDef>Numéro</th>
                                            <td mat-cell *matCellDef="let row">
                                                <span class="condition-cell-text"
                                                      [attr.title]="row.category.id">{{ row.category.id }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="remove">
                                            <th mat-header-cell *matHeaderCellDef aria-label="Supprimer"></th>
                                            <td mat-cell *matCellDef="let row" class="mat-cell-center-align">
                                                <button
                                                        type="button"
                                                        class="tv-icon-button-s-transparent"
                                                        [attr.aria-label]="'Supprimer ' + row.category.name"
                                                        (click)="removeCondition(row)">
                                                    <mat-icon class="material-icons-outlined condition-remove-icon">
                                                        delete
                                                    </mat-icon>
                                                </button>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="conditionColumns; sticky: true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: conditionColumns"></tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="isLoading" class="loading-overlay" role="status" aria-label="Chargement du formulaire">
                    <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
                </div>
            </div>

            <div class="button-edit">
                <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler
                </button>
                <button class="tv-ns-validation-large-button" [disabled]="isLoading"
                        (click)="onValidationButtonClick()">Valider
                </button>
            </div>
        </ng-container>
        <ng-template #savingContentTemplate>
            <div class="saving-content">
                <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </div>
        </ng-template>
    </div>
</ng-template>
